/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDefer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 1c4.018 0 7.152 2.745 9.002 4.917L21 4h2v6h-6V8l3.103.001C18.633 6.082 15.696 3 12 3c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9h2c0 6.065-4.935 11-11 11S1 18.065 1 12 5.935 1 12 1zm1 4v6h4v2h-6V5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDefer as Defer };
